import { Cog, Hammer, PackageOpen } from "lucide-react";
import { useMenuAccess } from "@/app/access";
import { SettledRules } from "@/components/ui/SettledRules";

/**
 * Quy tắc của Sản xuất — chốt 20/09/2026 theo chuẩn, khách bác lại được. Trước đây là ba khối vàng rải trên các màn con, mỗi khối
 * một đoạn văn dài kèm danh sách mã quy tắc; nay mỗi màn con đọc đúng bộ quy tắc của mình.
 *
 * Phần thật sự phải hỏi khách — lệnh mở từ đâu, nguyên tắc chọn lô, cách báo công, điều kiện đóng lệnh, phí gia công tính trên
 * lượng nào — nằm ở mục 28 bộ câu hỏi. Những câu đó là CHÍNH SÁCH của Hisense; ta chốt mặc định theo chuẩn để màn hình dùng được
 * ngay, không bịa ra con số nào của khách.
 */
export const ORDER_RULES_SETTLED = ["source", "snapshot", "release", "closing", "authority"] as const;
export const MATERIAL_RULES_SETTLED = ["custody", "picking", "returning"] as const;
export const EXEC_RULES_SETTLED = ["separate", "output", "subcontract"] as const;

export function ProductionOrderRules() {
  return <SettledRules ns="production" rules={ORDER_RULES_SETTLED} icon={Cog} />;
}
export function ProductionMaterialRules() {
  return <SettledRules ns="productionMaterials" rules={MATERIAL_RULES_SETTLED} icon={PackageOpen} />;
}
export function ProductionExecutionRules() {
  return <SettledRules ns="execution" rules={EXEC_RULES_SETTLED} icon={Hammer} />;
}

/** Cùng bộ giải quyền với máy chủ (ô tick menu Sản xuất) — trước 20/09/2026 mười một chỗ chặn cứng theo vai trò admin. */
export function useProductionAccess() {
  return useMenuAccess("production");
}
